/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class WordpressSelector extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    error={this.props.error}
                    headerCopy="Select a WordPress Blog"/>
                <ChooserMain
                    {...this.props}/>
            </div>
        );
    }
}

WordpressSelector.displayName = "WordpressSelector";

export default WordpressSelector;
